import { createStrictContext } from "../../js/react/hooks";
import { InventoryPartialRequest } from "./ProductInventory/types";

export interface IInventoryContext {
  getStoresForCart: (request: IDeliveryAddress) => Promise<InventoryResult[]>;
  getInventory: (
    request: ProductInventoryRequest
  ) => Promise<InventoryResult[]>;
  getPartialInventory: (
    request: InventoryPartialRequest
  ) => Promise<InventoryResult>;
}

export const [InventoryContextProvider, useInventoryContext] =
  createStrictContext<IInventoryContext>();
